import React from "react";
import { Dropdown, Spin } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import ActionsIcons from "../ActionsIcons/ActionsIcons";
import "./TableRowActions.scss";

const TableRowActions = React.memo(({ actions = [], menuItems = [], loading = false }) => {
   return (
      <div className="table-row-actions">
         {actions.length > 0 && <ActionsIcons actions={actions} />}
         {loading ? (
            <Spin spinning={loading}></Spin>
         ) : menuItems.length > 0 ? (
            <Dropdown
               menu={{ items: menuItems }}
               trigger={["click"]}
               placement="bottomRight"
               overlayClassName="table-row-actions__dropdown"
            >
               <button className="table-row-actions__more-btn icon-group" title="More actions">
                  <MoreOutlined className="icon-container" />
               </button>
            </Dropdown>
         ) : null}
      </div>
   );
});

TableRowActions.displayName = "TableRowActions";

export default TableRowActions;
